import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { OCC_METRIC_TOOLTIPS } from '../occ-metric-tooltips';

@Component({
    selector: 'app-occ-day-details-dialog',
    templateUrl: './occ-day-details-dialog.component.html',
    styleUrls: ['./occ-day-details-dialog.component.css'],
    standalone: false
})
export class OccDayDetailsDialogComponent implements OnInit {

  deviationOptions: any[] = [];
  selectedDeviationIds: number[] = [];

  dayOptions: any[] = [];
  selectedDays: number[] = [];

  metrics: any;  
  updates: any = {};
  metricTooltips = OCC_METRIC_TOOLTIPS;

  constructor(
    public dialogRef: MatDialogRef<OccDayDetailsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    this.deviationOptions = this.data.deviationOptions;
    this.dayOptions = this.data.dayOptions;

    this.selectedDeviationIds = [...this.data.selectedDeviationIds];
    this.selectedDays = [...this.data.selectedDays];

    this.metrics = this.data.metrics;
    // initialize updates as empty
    this.updates = {};
  }

  submit() {
    // remove empty values
    if (this.updates.pct == null) {
      this.dialogRef.close();
      return;
    }

    this.dialogRef.close({
      deviationIds: this.selectedDeviationIds,
      days: this.selectedDays,
      updatedFields: {
        pct: this.updates.pct / 100
      }
    });
}

  close() {
    this.dialogRef.close();
  }

  formatPct(value?: number): string {
    return value != null ? `${(value * 100).toFixed(0)}%` : '-';
  }

}
